import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { Checkbox } from '@daedalus/atlas/Checkbox';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { filterMessages } from '../filterMessages';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1bezwge",
  propsAsIs: false
});
interface Props {
  amenities: string[] | undefined;
  /** The callback fired on filter change */
  onChange: (filterName: string, filterValue: string | null | undefined) => void;
}
const MealPlansFilterComponent: React.FC<Props> = ({
  amenities,
  onChange
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    isMobile
  } = useDeviceLayout();
  return <Wrapper>
      <Checkbox key="breakfast" name="breakfast" value="breakfast" checked={amenities?.includes('breakfast')} onChange={() => onChange('amenities', 'breakfast')} label={formatMessage(filterMessages.breakfast)} labelSize={isMobile ? 'bodyM' : 'bodyS'} />
      <Checkbox key="allInclusive" name="allInclusive" value="allInclusive" checked={amenities?.includes('allInclusive')} onChange={() => onChange('amenities', 'allInclusive')} label={formatMessage(filterMessages.allInclusive)} labelSize={isMobile ? 'bodyM' : 'bodyS'} />
    </Wrapper>;
};
export const MealPlansFilter = memo(MealPlansFilterComponent);

require("./MealPlansFilter.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MealPlansFilter.tsx");